import Vue from "vue";
import simplebar from "simplebar-vue";
import {MinicartHeader, MinicartFooter, MinicartEmpty} from "./minicart/miniCartGeneral";
import { MinicartBrands } from "./minicart/miniCartBrands";

/**
 * Minicart Vue Component
 */
const MinicartComponent = Vue.extend({
    template: `
        <div class="minicart-container" v-if="resources">
            <minicart-header :resources="resources" :icon="closeIcon" :minicartDataLayerObject="minicartDataLayerObject" />

            <simplebar id="minicart-products-container" class="minicart-products-container" :class="{ 'minicart-products-empty': isCartEmpty, 'no-entrega-zero': !resources.customerAuthenticated }">
                <minicart-empty :resources="resources" :icon="emptyCartIcon" v-if="isCartEmpty" />
                <minicart-brands :itemsSortedByBrand="itemsSortedByBrand" :resources="resources" :trashIcon="trashIcon" :quantityInputIcons="quantityInputIcons" :brandsIcons="brandsIcons" :arrowUpIcon="arrowUpIcon" :arrowDownIcon="arrowDownIcon" :brandID="brandID" v-else />

                <minicart-footer v-if="isCartEmpty" :resources="resources" :icon="cartIcon" :is-empty="isCartEmpty" :sub-total="subTotal" :hide-zero-price="hideZeroPrice" :area-entrega-icon="areaEntregaIcon" :active-area-entrega-icon="activeAreaEntregaIcon"  />
            </simplebar>

            <minicart-footer v-if="!isCartEmpty" :resources="resources" :minimumOrderValueBlocked="minimumOrderValueBlocked" :icon="cartIcon" :infoIcon="infoIcon" :trashIcon="trashIcon" :is-empty="isCartEmpty" :sub-total="subTotal" :hide-zero-price="hideZeroPrice" :area-entrega-icon="areaEntregaIcon" :active-area-entrega-icon="activeAreaEntregaIcon" :campaignBenefitThreshold="campaignBenefitThreshold" />
        </div>`,
    components: {
        MinicartHeader,
        MinicartEmpty,
        MinicartFooter,
        MinicartBrands,
        simplebar
    }
});

export default MinicartComponent;
